import performRequest from "../config/AxiosConfig";

export const createDealer = async (body) => {
  let res = await performRequest("/dealers", "POST", body);
  return res;
};
